import { useCallback } from 'react'

export function usePassback(callback, obj) {
  return useCallback(() => callback && callback(obj), [callback, obj])
}
